import { Component } from '@angular/core';

// RxJS
import { Subject } from 'rxjs';

// Services
import { ProjectService } from '@modules/project/services/project.service';

// Types
import { MatDialogRef } from '@angular/material/dialog';
import { Project } from '@modules/project/types/project';

@Component({
    selector: 'app-create-project',
    templateUrl: './create-project.component.html',
    styleUrl: './create-project.component.less',
    standalone: false
})
export class CreateProjectComponent {

  // Public
  public name?: string;

  // Private
  private alive = new Subject<void>();

  /**
   * Constructor
   */

  constructor(
    public dialogRef: MatDialogRef<CreateProjectComponent>,
    private projectService: ProjectService,
  ) { }

  /**
   * Component lifecycle
   */

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this.alive.next();
    this.alive.complete();
  }

  /**
   * Methods
   */

  close(): void {
    this.dialogRef.close();
  }

  create(): void {
    if (this.name?.length) {
      const project = new Project();
      project.name = this.name;
      this.projectService.createProject(project);
      this.dialogRef.close();
    }
  }

}
